import { Button, Image, UIHeading1, UIHeading3 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import { MortgageAnnotations } from 'shared/components/MortgageAnnotations';
import { type TAdfoxBannerCompleteSizes } from 'shared/types/adfox';
import { Ticker } from 'shared/components/Ticker';

import styles from './TgbStretch.css';

export type TTgbStretchProps = {
  image: string;
  url: string;
  button: string | undefined;
  label: string | undefined;
  title: string;
  description: string;
  annotation: string | undefined;
  logoUrl: string | undefined;
  mortgageWarning: string | undefined;
  mortgageTermsWarning: string | undefined;
  sizes: TAdfoxBannerCompleteSizes;
};

export const TgbStretch: FC<TTgbStretchProps> = ({
  image,
  url,
  button,
  title,
  description,
  annotation,
  logoUrl,
  mortgageWarning,
  mortgageTermsWarning,
  label,
  sizes,
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      data-testid="tgb-stretch"
      href={url}
      target="_blank"
      rel="noreferrer noopener nofollow"
      className={clsx(
        styles['container'],
        (withMortgageAnnotations || !!annotation) && styles['container--with-annotation'],
      )}
      style={sizes}
    >
      <div className={styles['container-inner']} data-testid="container-inner">
        <div className={styles['content']} data-testid="content">
          <div className={styles['photo-block']} style={{ backgroundImage: `url(${image})` }} data-testid="photo-block">
            {!!label && (
              <div className={styles['photo-label']} data-testid="photo-label">
                <AdLabel label={label} />
              </div>
            )}
          </div>

          <div className={styles['main-content']} data-testid="main-content">
            <div className={styles['main-content-text']}>
              <UIHeading1 color="text-main-default" data-testid="title">
                {title}
              </UIHeading1>
              <UIHeading3 data-testid="description">{description}</UIHeading3>
            </div>
            <div className={styles['button-container']} data-testid="button-container">
              <Button data-testid="more-about-jk-button" fullWidth={false} theme="fill_primary" size="M">
                {button || 'Подробнее о ЖК'}
              </Button>
            </div>
          </div>

          {!!logoUrl && (
            <div className={styles['logo-container']} data-testid="logo-container">
              <Image src={logoUrl} borderRadius="4px" width={68} height={68} objectFit="contain" data-testid="logo" />
            </div>
          )}
        </div>

        {!!annotation && <Ticker withoutPadding theme="dark" text={annotation} />}

        {withMortgageAnnotations && (
          <MortgageAnnotations
            height={sizes.height}
            mortgageTermsWarning={mortgageTermsWarning}
            mortgageWarning={mortgageWarning}
          />
        )}
      </div>
    </a>
  );
};
